import { Injectable } from "@angular/core";
import { HttpClient, HttpHeaders } from "@angular/common/http";
import { Observable } from "rxjs";
import { GLOBAL } from "./global";

@Injectable({
  providedIn: "root"
})
export class DeclaracionService {
  public url: string;

  constructor(public _http: HttpClient) {
    this.url = GLOBAL.url;
  }

  getDeclaraciones(token): Observable<any> {
    let headers = new HttpHeaders()
      .set("Content-Type", "application/x-www-form-urlencoded")
      .set("Authorization", token);
    return this._http.get(this.url + "declaraciones", { headers: headers });
  }

  getDeclaracion(token, id): Observable<any> {
    let headers = new HttpHeaders()
      .set("Content-Type", "application/x-www-form-urlencoded")
      .set("Authorization", token);
    return this._http.get(this.url + "declaraciones/" + id, {
      headers: headers
    });
  }

  getFormaDeclarativa(token, id): Observable<any> {
    let headers = new HttpHeaders()
      .set("Content-Type", "application/x-www-form-urlencoded")
      .set("Authorization", token);
    return this._http.get(this.url + "getFormaDeclarativa/" + id, {
      headers: headers
    });
  }

  getDeclaracionesTypePayment(token, type): Observable<any> {
    let headers = new HttpHeaders()
      .set("Content-Type", "application/x-www-form-urlencoded")
      .set("Authorization", token);
    return this._http.get(this.url + "declaracionesByTypePayment/" + type, {
      headers: headers
    });
  }

  getDeclaracionesByEstatus(token, status): Observable<any> {
    let headers = new HttpHeaders()
      .set("Content-Type", "application/x-www-form-urlencoded")
      .set("Authorization", token);
    return this._http.get(this.url + "declaracionesByEstatus/" + status, {
      headers: headers
    });
  }

  getCountDeclaraciones(token): Observable<any> {
    let headers = new HttpHeaders()
      .set("Content-Type", "application/x-www-form-urlencoded")
      .set("Authorization", token);
    return this._http.get(this.url + "countDeclaraciones", {
      headers: headers
    });
  }

  getDeclaracionesAceptadas(token): Observable<any> {
    let headers = new HttpHeaders()
      .set("Content-Type", "application/x-www-form-urlencoded")
      .set("Authorization", token);
    return this._http.get(this.url + "getDeclaracionesAceptadas", {
      headers: headers
    });
  }

  debtors(token, info): Observable<any> {
    let json = encodeURIComponent(JSON.stringify(info));
    let params = "json=" + json;

    let headers = new HttpHeaders()
      .set("Content-Type", "application/x-www-form-urlencoded")
      .set("Authorization", token);
    // Url del back
    return this._http.post(this.url + "debtors", params, {
      headers: headers
    });
  }

  createDeclaracion(token, declaracion): Observable<any> {
    let json = encodeURIComponent(JSON.stringify(declaracion));
    let params = "json=" + json;

    let headers = new HttpHeaders()
      .set("Content-Type", "application/x-www-form-urlencoded")
      .set("Authorization", token);
    // Url del back
    return this._http.post(this.url + "declaraciones", params, {
      headers: headers
    });
  }

  pay(token, pase_caja): Observable<any> {
    let json = encodeURIComponent(JSON.stringify(pase_caja));
    let params = "json=" + json;

    let headers = new HttpHeaders()
      .set("Content-Type", "application/x-www-form-urlencoded")
      .set("Authorization", token);
    // Url del back
    return this._http.post(this.url + "pagar_banco", params, {
      headers: headers
    });
  }

  declararCeros(token, image: any, id): Observable<any> {
    let headers = new HttpHeaders().set("Authorization", token);
    return this._http.post(this.url + "declararCeros/" + id, image, {
      headers: headers
    });
  }

  declarar(token, info): Observable<any> {
    let json = encodeURIComponent(JSON.stringify(info));
    let params = "json=" + json;

    let headers = new HttpHeaders()
      .set("Content-Type", "application/x-www-form-urlencoded")
      .set("Authorization", token);
    // Url del back
    return this._http.post(this.url + "declarar", params, { headers: headers });
  }

  attachFileByDeclaracion(token, image: any, id): Observable<any> {
    let headers = new HttpHeaders().set("Authorization", token);
    return this._http.post(this.url + "attachFileByDeclaracion/" + id, image, {
      headers: headers
    });
  }

  getDocumentoDeclaracion(token, id): Observable<any> {
    let headers = new HttpHeaders().set("Authorization", token);
    return this._http.get(this.url + "getDocumento/" + id, {
      headers: headers,
      responseType: "blob"
    });
  }

  update(token, id, estatus): Observable<any> {
    let json = encodeURIComponent(JSON.stringify(estatus));
    let params = "json=" + json;
    let headers = new HttpHeaders()
      .set("Content-Type", "application/x-www-form-urlencoded")
      .set("Authorization", token);
    // Url del back
    return this._http.put(this.url + "declaraciones/" + id, params, {
      headers: headers
    });
  }
}
